interface Filters {
  [key: string]: string | string[] | FilterObject
}

interface FilterObject {
  id?: number
  start_date?: string
  end_date?: string
  startDate?: string
  endDate?: string
  defaultValue?: string | string[]
  value?: string
  state?: string
  name?: string
  label?: string
}

interface FilterValues {
  [key: string]:
    | string
    | string[]
    | FilterObject
    | { value: string | number | boolean | string[] }
}

/**
 * Cleans up filter values for URL params
 */
export const cleanUpValues = (
  filters: Filters | null | undefined,
): FilterValues | null => {
  if (!filters) {
    return null
  }

  // USED TO PARSE VALUES FOR URL PARAMS
  const filterValues: FilterValues = {}

  for (const key in filters) {
    const filter = filters[key]

    if (Array.isArray(filter)) {
      continue
    }

    if (
      key === 'dates' ||
      (typeof filter === 'object' && (filter.start_date || filter.end_date))
    ) {
      if (typeof filter === 'object') {
        // Handle timeframe dates
        if (filter.startDate) {
          filterValues.start_date = { value: filter.startDate }
        }

        if (filter.endDate) {
          filterValues.end_date = { value: filter.endDate }
        }

        // Handle date ranges inside filter menu
        if (filter.start_date) {
          filterValues[key !== 'dates' ? `${key}_start_date` : 'start_date'] = {
            value: filter.start_date,
          }
        }

        if (filter.end_date) {
          filterValues[key !== 'dates' ? `${key}_end_date` : 'end_date'] = {
            value: filter.end_date,
          }
        }
      }
    } else if (key === 'include' || key === 'exclude') {
      // Handle include/exclude filters
      if (typeof filter === 'object' && filter.defaultValue) {
        filterValues[key] = { value: filter.defaultValue }
      }
    } else if (typeof filter === 'object' && filter.id && filter.id > 0) {
      // Handle filters with IDs > 0
      if (key === 'fulfillment' && filter.value) {
        filterValues[filter.value] = { value: true }
      } else if (key === 'warehouse_status' && filter.state) {
        filterValues[key] = { value: filter.state }
      } else if (key === 'purchase_order_states' && filter.state) {
        filterValues[key] = { value: filter.state }
      } else {
        filterValues[key] = filter
      }
    } else if (typeof filter === 'string' && filter !== '') {
      filterValues[key] = filter
    }
  }

  // Return null if no filters were processed
  if (Object.keys(filterValues).length === 0) {
    return null
  }

  return filterValues
}

/**
 * Compares two arrays to check if they contain the same elements
 */
export const compareArrays = <T>(
  first: T[] | null | undefined,
  second: T[] | null | undefined,
): boolean => {
  if (!first || !second) return false

  return (
    first.every((e) => second.includes(e)) &&
    second.every((e) => first.includes(e))
  )
}
